export default {
  /**
   * 用户登录
   */
  LOGIN: 'LOGIN',
  /**
   * 设置标题
   */
  SET_TITLE: 'SET_TITLE',
  /**
   * 设置追踪码
   */
  SET_SHARE_CODE: 'SET_SHARE_CODE',
  /**
   * 设置当前的队伍成员
   */
  SET_CURRENT_MEMBER: 'SET_CURRENT_MEMBER',
  /**
   * 设置是否加入了队伍
   */
  SET_JOINED_TEAM: 'SET_JOINED_TEAM',
  /**
   * 设置助力规则
   */
  SET_ASSIST_RULE: 'SET_ASSIST_RULE',
  /**
   * 设置队长udi
   */
  SET_TEAM_LEADER: 'SET_TEAM_LEADER',
  /**
   * 设置自己队伍名次
   */
  SET_MY_TEAM_RANK: 'SET_MY_TEAM_RANK',
  /**
   * 设置队伍榜单
   */
  SET_TEAM_RANK: 'SET_TEAM_RANK',
  /**
   * 设置头图信息
   */
  SET_HEADER_INFO: 'SET_HEADER_INFO',
  /**
   * 设置额外信息
   */
  SET_SHARE_EXTRA_INFO: 'SET_SHARE_EXTRA_INFO',
  /**
   * 设置分享链接
   */
  SET_SHARE_LINK: 'SET_SHARE_LINK',
  /**
   * 设置奖励记录
   */
  SET_RECORDS: 'SET_RECORDS',
  /**
   * 队伍下周最少可得
   */
  SET_TEAM_MIN_OBTAIN: 'SET_TEAM_MIN_OBTAIN',
  /**
   * 设置上次获得奖励的内容
   */
  SET_PREVIEW_PRIZE_STATUS: 'SET_PREVIEW_PRIZE_STATUS',
  /**
   * 设置领奖弹框是否已经出现
   */
  SET_HAS_PRIZE_DIALOG_OPEN: 'SET_HAS_PRIZE_DIALOG_OPEN',
  /**
   * 设置上期领奖的数量
   */
  SET_PREVIEW_PRIZE_NUMBER: 'SET_PREVIEW_PRIZE_NUMBER',
  /**
   * 页面数据准备好了
   */
  SET_PAGE_DATA_READY: 'SET_PAGE_DATA_READY',
  /**
   * 设置排名数据准备好了
   */
  SET_RANK_DATA_READY: 'SET_RANK_DATA_READY',
  /**
   * 设置PV已经上报过
   */
  SET_PV_TRACKED: 'SET_PV_TRACKED',
  /**
   * 设置图片HOST
   */
  SET_HOST: 'SET_HOST',
  /**
   * 设置没有记录弹框
   */
  SET_SHOW_NO_RECORD: 'SET_SHOW_NO_RECORD',
  /**
   * 设置成功加入弹框
   */
  SET_SHOW_JOIN: 'SET_SHOW_JOIN',
  /**
   * 设置当前的激活tab
   */
  SET_CURRENT_TAB: 'SET_CURRENT_TAB',
  /**
   * 设置是否为黑名单队伍
   */
  SET_BLACKLISTTEAM: 'SET_BLACKLISTTEAM'
};
